import React from "react";
import { useQuery } from "@apollo/client";
import { HeadingComponent } from "../components/shared/HeadingComponent";
import { GetAppAnonymousDocument, GetTenantDocument, ListUserRolesDocument, ListUsersDocument } from "../gql/graphql";
export function GraphqlExpoScreen() {
  const getTenantQuery = useQuery(GetTenantDocument);
  const listUsersQuery = useQuery(ListUsersDocument);
  const listUserRolesQuery = useQuery(ListUserRolesDocument);
  const getAppAnonymousQuery = useQuery(GetAppAnonymousDocument);
  const renderJson = data => {
    return data ? /*#__PURE__*/React.createElement("pre", null, JSON.stringify(data, null, "\t")) : "";
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h1",
    size: "3xl"
  }, "Queries"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h2",
    size: "2xl"
  }, "getTenant.query.graphql (GetTenantDocument)"), renderJson(getTenantQuery.data?.getTenant)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h2",
    size: "2xl"
  }, "listUsers.query.graphql (ListUsersDocument)"), renderJson(listUsersQuery.data?.listUsers)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h2",
    size: "2xl"
  }, "listUserRoles.query.graphql (ListUserRolesDocument)"), renderJson(listUserRolesQuery.data?.listUserRoles)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h2",
    size: "2xl"
  }, "getAppAnonymous.query.graphql (GetAppAnonymousDocument)"), renderJson(getAppAnonymousQuery.data?.getAppAnonymous)));
}